import { getObjectTypedKeys } from 'augment-vir';
export function createRenderParams(element, eventsMap) {
    const renderParams = {
        /**
         * These two dispatch properties do the same thing but their interfaces are different.
         * DispatchEvent's type interface is much stricter.
         */
        dispatch: (event) => element.dispatchEvent(event),
        genericDispatch: (event) => element.dispatchEvent(event),
        setProps: (partialProps) => {
            getObjectTypedKeys(partialProps).forEach((propKey) => {
                element.instanceProps[propKey] = partialProps[propKey];
            });
        },
        host: element,
        props: element.instanceProps,
        events: eventsMap,
    };
    return renderParams;
}
